import { v4 as uuidv4 } from 'uuid';

const DEVICE_ID_KEY = process.env.REACT_APP_DEVICE_ID_KEY || 'kf-device-id';

const DeviceService = {
  getDeviceId: (): string | undefined => {
    let deviceId = localStorage.getItem(DEVICE_ID_KEY);

    if (deviceId === null) {
      deviceId = uuidv4();
      localStorage.setItem(DEVICE_ID_KEY, deviceId);
    }
    return deviceId;
  },
};
export default DeviceService;
